module.exports = __webpack_public_path__ + "static/media/images_logo-large.e600d8a6.png";